import { keyframes } from "@emotion/react";
import styled from "@emotion/styled/macro";
import { colors } from "../../../../common/styles/theme.styles";

export const VaultUploadHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--Main-Colors-Light-Grey-2, #F1F3F5);
    padding: 10px 16px 10px 40px;
    width: 100%;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
`;

export const VaultUploadHeaderRight = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

export const VaultUploadHeaderSecureTag = styled.div`
    display: inline-flex;
    height: 36px;
    padding: 0px 12px 0px 8px;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;

    border-radius: 8px;
    background: var(--Main-Colors-Light-Grey-2, #F1F3F5);

    color: var(--Dark-Gray-2, #585D66);
    font-size: 16px;
    font-weight: 450;
`;

export const VaultUploadHeaderClose = styled.div`
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;

    cursor: pointer;

    &:hover {
        filter: brightness(0.8);
    }
`;

export const VaultUploadBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 28px 40px;
`;

export const VaultUploadDragAndDropArea = styled.div`
    display: inline-flex;
    padding: 153px 251.5px 140px 251.5px;
    justify-content: center;
    align-items: center;

    border-radius: 8px;
    border: 1px dashed var(--Dark-Gray-1, #1A1B1D);
    background: var(--White, #FFF);

    ${({ isDragActive }) => isDragActive && `
        background: var(--Main-Colors-Light-Grey-2, #F1F3F5);
    `}
`;

export const VaultUploadDragAndDropAreaDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

export const VaultUploadDragAndDropAreaText = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    color: var(--Dark-Gray-1, #1A1B1D);
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    line-height: normal;

    div:not(:first-of-type) {
        font-size: 14px;
        font-weight: 450;
    }
`;

export const VaultLoaderWrapper = styled.div`
    display: flex;
    height: 44px;
    width: 100%;
    justify-content: center;
    align-items: center;
`;

export const VaultUploadDragAndDropAreaButton = styled.div`
    display: flex;
    height: 44px;
    padding: 0px 24px 0px 20px;
    justify-content: center;
    align-items: center;
    gap: 6px;

    border-radius: 40px;
    background: var(--Dark-Gray-1, #1A1B1D);

    color: var(--White, #FFF);
    font-size: 16px;
    font-weight: 450;
    line-height: normal;

    cursor: pointer;

    &:hover {
        background: var(--Dark-Gray-2, #282C2E);
    }
`;

export const VaultUploadNotice = styled.div`
    display: inline-flex;
    padding: 40px 0px 56px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;

    border-radius: 40px;
`;

export const VaultUploadNoticeTitle = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 6px;

    color: var(--Dark-Gray-1, #1A1B1D);
    font-size: 16px;
    font-weight: 500;
`;

export const VaultUploadNoticeDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;

    color: var(--Dark-Gray-2, #585D66);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 450;
    line-height: normal;
`;

export const VaultUploadNoticeLink = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    color: var(--Color-System-Simulations, #2565E7);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    a {
        color: inherit;

        &:hover {
            text-decoration: underline;
        }
    }
`;

export const UploadAnimatedBarWrapper = styled.div`
    background-color: ${colors.gray3};
    height: 2px;
    position: relative;
    width: 100%;
`;

const progressBar = keyframes`
    0% { left:0; width: 0; }
    50% { left:0; width: 100% }
    100% { left:100%; width: 0 }
`;

export const UploadAnimatedBar = styled.div`
    background-color: ${colors.darkGray1};
    height: 2px;
    width: 100%;
    position: absolute;
    /* transition : width 5s ease; */
    animation: ${progressBar} 5s ease-in-out infinite;
`;